import React from "react";
import { observer } from "mobx-react";
import UiMeet3dGeneralPage from "~/modules/UiMeet3d/app/UiMeet3dGeneralPage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
import "../styles/TourLayout.less";

const ClientPanelUiMeet3dGeneralPage = observer(props => <UiMeet3dGeneralPage {...props} />);

export default ClientPanelUiMeet3dGeneralPage;
